import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/home/Hero';
import { Stats } from '@/components/home/Stats';
import { Logos } from '@/components/home/Logos';
import { Features } from '@/components/home/Features';
import { HowItWorks } from '@/components/home/HowItWorks';
import { Testimonials } from '@/components/home/Testimonials';
import { Pricing } from '@/components/home/Pricing';
import { ComparisonTable } from '@/components/home/ComparisonTable';
import { FAQ } from '@/components/home/FAQ';
import { CTA } from '@/components/home/CTA';

export function HomePage() {
  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Header />
      <Hero />
      <Stats />
      <Logos />
      <Features />
      <HowItWorks />
      <Testimonials />
      <Pricing />
      <ComparisonTable />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
